import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/auth/useAuth";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { UserManagement } from "@/components/admin/UserManagement";
import { BaseAssignments } from "@/components/admin/BaseAssignments";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet-async";

const Admin = () => {
  const { isAdmin, loading, checkIsAdmin } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const verifyAdmin = async () => {
      try {
        // Refresh the admin status
        await checkIsAdmin();
      } catch (error) {
        console.error("Error checking admin status:", error);
        toast.error("Failed to verify admin status");
      } finally {
        setIsChecking(false);
      }
    };

    if (!loading) {
      verifyAdmin();
    }
  }, [loading, checkIsAdmin]);

  if (loading || isChecking) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (!isAdmin) {
    toast.error("You don't have permission to access the admin area");
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container mx-auto py-6 px-4">
      <Helmet>
        <title>Admin | CRM</title>
      </Helmet>
      
      <AdminHeader />
      
      <Tabs defaultValue="users" className="mt-8">
        <TabsList className="grid w-full grid-cols-2 mb-6">
          <TabsTrigger value="users">User Management</TabsTrigger>
          <TabsTrigger value="bases">Base Assignments</TabsTrigger>
        </TabsList>
        
        <TabsContent value="users">
          <UserManagement />
        </TabsContent>
        
        <TabsContent value="bases">
          <BaseAssignments />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Admin;
